import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/payment-statistics', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const academicYear = (Options = {}) => {
    return httpClient
        .get('/api/payment-statistics/academic-years', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default {
    get,
    academicYear
}